export default __webpack_public_path__ + "static/media/photo3.df28f2df.jpg";